import * as Common from "../Common/modules";
import * as Models from "../Models";
import Index = require("../Models/Customer/index");

export interface ISystemApiClient {
  removeInverterType: (itemId: number) => ng.IPromise<boolean>;
  postInverterType: (item: Models.SystemDetails.InverterTypeModel.InverterTypeModel) => ng.IPromise<Models.SystemDetails.InverterTypeModel.InverterTypeModel>;
  submitSystemDetails(submitSystemDetails: Models.SystemDetails.SystemDetails.SystemDetails): ng.IPromise<any>;
  manageSystemDetails(submitSystemDetails: Models.SystemDetails.SystemDetails.SystemDetails): ng.IPromise<any>;
  getSystemDetails(identifier: string): ng.IPromise<Models.SystemDetails.SystemDetails.SystemDetails[]>;
  reconcileSystemDetails(systemDetails: Models.SystemDetails.SystemDetails.SystemDetails): ng.IPromise<Models.CostCalculation.EpcCalculation.IContractAssociatedEpcCalculationResult>;
  getInverterTypes(): ng.IPromise<Models.SystemDetails.InverterTypeModel.InverterTypeModel[]>;
  getEditableInverterTypes(): ng.IPromise<Models.SystemDetails.InverterTypeModel.InverterTypeModel[]>;
  getComponents(): ng.IPromise<Models.Customer.SystemComponent.Component[]>;
  getActiveComponents(): ng.IPromise<Models.Customer.SystemComponent.Component[]>;
  upsertComponent(component: Models.Customer.SystemComponent.Component): ng.IPromise<Models.Customer.SystemComponent.Component>;
  deleteComponent(componentId: number): ng.IPromise<any>;
  getModuleTypes(): ng.IPromise<Models.SystemDetails.ModuleTypeModel.ModuleTypeModel[]>;
  getActiveSafeHarborComponents(): ng.IPromise<Models.Customer.SystemComponent.Component[]>;
  getActiveComponentsForCustomersPartner(igsCustomerNumber: string): ng.IPromise<Models.Customer.SystemComponent.Component[]>;
}

export class SystemApiClient implements ISystemApiClient {
  public static $inject = ["igs.apiClientService"];

  public systemDetailsPrefix: string;

  constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    this.systemDetailsPrefix = "SystemDetails";
  }

  public submitSystemDetails = (systemDetails: Models.SystemDetails.SystemDetails.SystemDetails): ng.IPromise<any> => {
    return this.igsApiClientService.post(this.systemDetailsPrefix, systemDetails);
  }

  public manageSystemDetails = (systemDetails: Models.SystemDetails.SystemDetails.SystemDetails): ng.IPromise<any> => {
    return this.igsApiClientService.post("ManageSystemDetails", systemDetails);
  }

  public getSystemDetails = (identifier: string): ng.IPromise<Models.SystemDetails.SystemDetails.SystemDetails[]> => {
    const url = `${this.systemDetailsPrefix}/${identifier}`;
    return this.igsApiClientService.get(url);
  }

  public reconcileSystemDetails = (systemDetails: Models.SystemDetails.SystemDetails.SystemDetails): ng.IPromise<Models.CostCalculation.EpcCalculation.IContractAssociatedEpcCalculationResult> => {
    const url = `${this.systemDetailsPrefix}/Reconcile`;
    return this.igsApiClientService.post(url, systemDetails);
  }

  public getInverterTypes = (): ng.IPromise<Models.SystemDetails.InverterTypeModel.InverterTypeModel[]> => {
    return this.igsApiClientService.get("GetInverterTypes");
  }

  public getEditableInverterTypes = (): ng.IPromise<Models.SystemDetails.InverterTypeModel.InverterTypeModel[]> => {
    return this.igsApiClientService.get("GetEditableInverterTypes");
  }

  public removeInverterType = (itemId: number): ng.IPromise<boolean> => {
    const url = `${this.systemDetailsPrefix}/RemoveInverterType/${itemId}`;
    return this.igsApiClientService.post(url, itemId);
  }

  public postInverterType = (item: Models.SystemDetails.InverterTypeModel.InverterTypeModel): ng.IPromise<Models.SystemDetails.InverterTypeModel.InverterTypeModel> => {
    const url = `${this.systemDetailsPrefix}/PostInverterType`;
    return this.igsApiClientService.post(url, item);
  }

  public getComponents = (): ng.IPromise<Models.Customer.SystemComponent.Component[]> => {
    return this.igsApiClientService.get("GetComponents");
  }

  public getActiveComponents = (): ng.IPromise<Models.Customer.SystemComponent.Component[]> => {
    return this.igsApiClientService.get("GetActiveComponents");
    }

    public getActiveComponentsForCustomersPartner = (igsCustomerNumber: string): ng.IPromise<Models.Customer.SystemComponent.Component[]> => {
        const url = `GetActiveComponentsForCustomersPartner/${igsCustomerNumber}`;
        return this.igsApiClientService.get(url);
    }

  public upsertComponent = (component: Models.Customer.SystemComponent.Component): ng.IPromise<Models.Customer.SystemComponent.Component> => {
    return this.igsApiClientService.post("UpsertComponent", component);
  }

  public deleteComponent = (componentId: number): ng.IPromise<any> => {
    return this.igsApiClientService.post(`DeleteComponent/${componentId}`, null);
  }

  public getModuleTypes = (): ng.IPromise<Models.SystemDetails.ModuleTypeModel.ModuleTypeModel[]> => {
    const url = `${this.systemDetailsPrefix}/GetModuleTypes`;
    return this.igsApiClientService.get(url);
  }

  public getActiveSafeHarborComponents = (): ng.IPromise<Models.Customer.SystemComponent.Component[]> => {
    return this.igsApiClientService.get("Components/SafeHarbor");
  }
}
